import { useEffect, useRef, useState } from "react";
import "./AcedDropdown.scss";

type Option = {
  value: string;
  label: string;
};

type CustomDropdownProps = {
  options: Option[];
  label?: string;
  defaultValue?: string;
};

function CustomDropdown({ options, label, defaultValue }: CustomDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<Option | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleOptionClick = (option: Option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const toggleDropdown = () => setIsOpen((prev) => !prev);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown-wrapper" ref={dropdownRef}>
      <div className="dropdown-text">
        {label && <label className="dropdown-label">{label}</label>}

        <div className="dropdown-toggle" onClick={toggleDropdown}>
          {selected ? selected.label : defaultValue}
        </div>
      </div>

      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option: any) => (
            <li
              key={option.value}
              className="dropdown-option"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomDropdown;
